import {
  VILLAGE_LIST,
  VILLAGE_CHANGE_STATUS,
  VILLAGE_ADDEDIT,
  VILLAGE_DELETE,
} from "../../api/constApi";
import { authHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";

export const VillageListApi = (payload) => {
  return apiInstance.post(VILLAGE_LIST, payload, {
    headers: authHeader(),
  });
};

export const villageChangeStatusApi = (payload) => {
  return apiInstance.post(VILLAGE_CHANGE_STATUS, payload, {
    headers: authHeader(),
  });
};

export const AddEditVillageApi = (payload) => {
  return apiInstance.post(VILLAGE_ADDEDIT, payload, {
    headers: authHeader(),
  });
};

export const villageDeleteApi = (payload) => {
  return apiInstance.post(VILLAGE_DELETE, payload, {
    headers: authHeader(),
  });
};
